import React from 'react';
import FilteredAutomationList from '../components/FilteredAutomationList';

const BothAgentsMissing = () => {
    const breadcrumbItems = [
        { label: 'Home', href: '/' },
        { label: 'Automation Trigger', href: '/automation' },
        { label: 'Both Agents Missing', active: true }
    ];

    return (
        <FilteredAutomationList
            completionStatus="both_agents_missing"
            title="Both Agents Missing"
            subtitle="Automation runs where both listing and selling agents are missing"
            breadcrumbItems={breadcrumbItems}
        />
    );
};

export default BothAgentsMissing;